// extracted by mini-css-extract-plugin
module.exports = {"imageWithCaption":"ImageWithCaption-module--image-with-caption--3ZiYb","imageWithCaption__image":"ImageWithCaption-module--image-with-caption__image--1FG02"};